module.exports = __webpack_public_path__ + "media/images/sp/stores/nagoya/access/nagoya_point2_3-b6689c259fba70d537015965f14b1703.jpg";